import viewReport from './viewReport';

export default {
	viewReportPage: viewReport
}